import {MI} from "../init";
import {commander, wallet} from "../../framework/src/engine/madnes/madnes_variables";
import { madnes_get_game_specifics } from "../../framework/src/engine/madnes/madnes";

/**
 * @constructor
 */
export function GameMemory() {

    this._wildMemory = [];

    /** @type {Array} */
    this._noJBReel;

    /** @type {?Object} */
    this._gameSpecifics;

    this._serverBetSet = [];

    /** @type {ServerConfig} */
    this._serverConfig;
}

/** @param {ServerConfig} serverConfig */
GameMemory.prototype.init = function(serverConfig) {

    this._serverConfig = serverConfig;
    this._gameSpecifics = serverConfig.getGameSpecifics();
    this._wildMemory = this._gameSpecifics["specialState"]["wildMemory"];
    this._noJBReel = this._gameSpecifics["specialState"]["noJBReel"];

    this._serverBetSet = wallet.getBetSet();
};

/** @param {ServerResult} serverResult */
GameMemory.prototype.reinit = function(serverResult) {
    this._gameSpecifics = madnes_get_game_specifics()
    this._wildMemory = this._gameSpecifics["specialState"]["wildMemory"];
    this._noJBReel = this._gameSpecifics["specialState"]["noJBReel"];
    this._serverBetSet = wallet.getBetSet();
};

GameMemory.prototype.getWildMemory = function() {
    var i = this.getWildMemoryIndex();

    if(i < 0) {
        return;
    }

    return this._wildMemory[i];
};

GameMemory.prototype.getWildMemoryIndex = function() {
    return this._serverBetSet.indexOf(MI.getAtomicBet());
};

GameMemory.prototype.getNoJBReel = function() {
    if(commander.game.round.getId() > 1 || !this._serverConfig.getMatrixNoJBReel()) {
        return this._noJBReel;
    } else {
        return this._serverConfig.getMatrixNoJBReel();
    }

};